module.exports = __webpack_public_path__ + "img/CDR.ed6396ab.png";